import { MouseEventHandler } from "react";

export default function Modal({ close, children, contentClassName }: { close: MouseEventHandler<HTMLDivElement>, children: any, contentClassName?: string }) {
    const handleStopPropagationClick = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation()
    };
    return (
        <div onClick={close} className="fixed z-10 bg-black/50 inset-0 flex flex-col items-center px-3 py-[40px] overflow-auto">
            <div onClick={handleStopPropagationClick} className={contentClassName || "bg-white w-full md:w-1/2 p-5 rounded-lg"}>
                {children}
            </div>
        </div>
    )
}
